import React, { memo } from "react";
import AtivoProvider from "../../../contexts/AtivosContext";
import AtivoOverview from "./AtivoOverview";
const Ativo = memo(() => {
  return <AtivoProvider>
      <AtivoOverview />
    </AtivoProvider>;
});
export default Ativo;
